/**ECG 点击某个item的下标*/
const SET_ECG_ITEM_INDEX = 'SET_ECG_ITEM_INDEX'
const state = {
    ecgItemIndex: 0,
    doctorId: null,
    isLogin: false,
    fullscreen: true,
    windowWidth: 0,
    windowHeight: 0,
    asideHeight: 0,
}

const mutations = {
    /*ECG*/
    [SET_ECG_ITEM_INDEX](state, index) {
        state.ecgItemIndex = index;
    },
    /*Login*/ 
    signin(state,doctorId){
        state.isLogin = true
        console.log("signin ----- state.isLogin = " + state.isLogin)
        sessionStorage.setItem("doctorId",doctorId);
        state.doctorId = doctorId;
    },
    signout(state){
        state.isLogin = false
        console.log("signout ------ state.isLogin = " + state.isLogin)
        //登出的时候，清空sessionStorage里的东西
        sessionStorage.setItem("doctorId",null);
        state.doctorId = null;
    },
    /*窗体是否显示全屏 即大于1400px*/
    updateFullscreen(state, data) {
        state.fullscreen = data
    },
    updateWindowWidth(state, data) {
        state.windowWidth = data
    },
    updateWindowHeight(state, data) {
        state.windowHeight = data
    },
    updateAsideHeight(state, data) {
        state.asideHeight = data
    },
}

const actions = {
    updateFullscreen({
        commit
    }, data) {
        commit("updateFullscreen", data);
    },
    updateWindowWidth({
        commit
    }, data) {
        commit("updateWindowWidth", data);
    },
    updateWindowHeight({
        commit
    }, data) {
        commit("updateWindowHeight", data);
    },
    updateAsideHeight({
        commit
    }, data) {
        commit("updateAsideHeight", data);
    },
}

const getters = {
    ecgItemIndex: state => state.ecgItemIndex,
    isLogin: state => state.isLogin,
    doctorId: state => state.doctorId,
    fullscreen: state => state.fullscreen,
    windowWidth: state => state.windowWidth,
    windowHeight: state => state.windowHeight,
    asideHeight: state => state.asideHeight
}

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations,
    SET_ECG_ITEM_INDEX
};